module.exports = __webpack_public_path__ + "static/media/session8grayscale.6ca9b5d0.svg";